(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guide-placements"] && !Shopify.designMode) return;
  try {
    
  function initGuideCarousels() {
    document.querySelectorAll('[data-guide-carousel]').forEach((root) => {
      if (root.dataset.guideReady === 'true') return;
      const track = root.querySelector('.guide-placements__track');
      const prev = root.querySelector('[data-guide-prev]');
      const next = root.querySelector('[data-guide-next]');
      if (!track || !prev || !next) return;

      const slides = [...track.querySelectorAll('.guide-placements__slide')];

      const slideLeft = (slide) => {
        const origin = slides[0] ? slides[0].offsetLeft : 0;
        return slide.offsetLeft - origin;
      };

      const currentIndex = () => {
        const left = track.scrollLeft;
        let best = 0;
        let bestDist = Infinity;
        slides.forEach((slide, index) => {
          const dist = Math.abs(slideLeft(slide) - left);
          if (dist < bestDist) {
            bestDist = dist;
            best = index;
          }
        });
        return best;
      };

      const goTo = (index) => {
        const target = slides[Math.max(0, Math.min(slides.length - 1, index))];
        if (!target) return;
        track.scrollTo({ left: slideLeft(target), behavior: 'smooth' });
      };

      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };

      prev.addEventListener('click', () => goTo(currentIndex() - 1));
      next.addEventListener('click', () => goTo(currentIndex() + 1));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      root.dataset.guideReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuideCarousels);
  } else {
    initGuideCarousels();
  }
  document.addEventListener('shopify:section:load', initGuideCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
